import Vue from 'vue'

const MenuDetail = Vue.component('menu-detail', {
	props: ["data"],
	data: function() {
		return {
		   CUSTOMER: __CUSTOMER__
		}
	},
	template: '#menu_detail',
	methods: {
		resetForm() {
			this.$parent.$refs.view.reset();
		}
	}
})

export default MenuDetail;
